export default "__VITE_ASSET__bb692ad8__"